import * as styles from "./Separator.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { Separator as BaseSeparator } from "@base-ui/react/separator";

import type { SeparatorProps } from "./Separator.types";

export function Separator({
  orientation = "horizontal",
  className,
  ...props
}: SeparatorProps): JSX.Element {
  return (
    <BaseSeparator
      data-slot="separator"
      orientation={orientation}
      className={clsx(styles.separator({ orientation }), className)}
      {...props}
    />
  );
}
